
const homePages = []

export default homePages